import React from 'react';
export function Footer() {
  return <footer className="bg-hyrox-dark border-t border-hyrox-muted py-12 px-4 text-center" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        <p className="text-gray-400 font-medium mb-2" data-id="element-64">
          Stock Digital™ — stockdigital.shop
        </p>
        <p className="text-gray-500 text-sm" data-id="element-65">
          Porque entrenar HYROX con criterio no debería costar años de
          improvisación.
        </p>
        <div className="flex justify-center gap-6 mt-6 text-xs text-gray-600" data-id="element-66">
          <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-67">
            Términos y condiciones
          </a>
          <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-68">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-69">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}